import React from 'react';
import { translate } from '../../../Services/translation';
import styled from 'styled-components';
import { grid, cells } from '../../../styling/utils/grid';
import { getColor } from '../../../styling/mixins/colors';
import { text } from '../../../styling/mixins/typography';

const StyledOrderDesktopItemOmnium = styled.li<{ customProp: boolean }>`
  display: grid;
  ${(props) => (props.customProp ? cells(10) : cells(7))}
  padding: ${(props) => (props.customProp ? '0.4rem' : '0.8rem')};
  gap: ${(props) => (props.customProp ? '0.8rem' : '1.6rem')};
  border-bottom: 1px solid ${getColor('grey', 300)};

  &:nth-child(odd) {
    background-color: ${getColor('white')};
  }

  &:last-child {
    border-bottom: none;
  }

  span {
    ${text('large')}
  }

  .grid-span-2 {
    grid-column: span 2 / span 2;
  }

  a {
    ${text('large')}
    color: ${getColor('gray', 900)};
    cursor: pointer;
    text-decoration: underline;
    text-align: right;
  }
`;

const OrderListItemDesktopOmnium = ({
  order,
  onClick,
  showTrackingNumber,
}) => {
  const shipments = showTrackingNumber
    ? order.shipments
    : [order.shipments[0]];

  return (
    <>
      {shipments.map((shipment, index) => (
        <StyledOrderDesktopItemOmnium
          key={index}
          customProp={showTrackingNumber}
        >
          <span>{order.orderNumber}</span>
          <span>{order.orderItemsCount}</span>
          <span className={showTrackingNumber ? 'grid-span-2' : ''}>
            {order.orderTotalInclVat} {order.currencyCode}
          </span>
          <span>{order.placedDate}</span>
          {showTrackingNumber && (
            <span className="grid-span-2">
              {shipment.trackingLink ? (
                <a
                  href={shipment.trackingLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  {shipment.trackingNumber}
                </a>
              ) : (
                shipment.trackingNumber
              )}
            </span>
          )}
          <span>
            {translate(
              `orderlist.orderstate.${order.status.toLowerCase()}`
            )}
          </span>
          <span>
            {showTrackingNumber && shipments.length > 1 && (
              <>
                {translate('orderlist.package')} {index + 1}{' '}
                {translate('orderlist.of')} {order.shipments.length}
              </>
            )}
          </span>
          <a onClick={() => onClick && onClick(order)}>
            {translate('orderlist.column.readmore')}
          </a>
        </StyledOrderDesktopItemOmnium>
      ))}
    </>
  );
};
export default OrderListItemDesktopOmnium;
